<template>
	<div class="message-wrap">
		<div v-if="dataList.length>0">
			<div v-for="(item, index) in dataList" :key="index">
				<commentItem :item="item"/>
			</div>
		</div>
		<Empty v-else content="暂无数据"/>
		<div v-if="total>pageSize">
			<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
		</div>
	</div>
</template>

<script>
	import commentItem from '@/components/message/commentItem'
	import Empty from '@/components/empty'
	import Pagination from '@/components/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'systemMessage',
		components: {
			commentItem,
			Empty,
			Pagination
		},
		data(){
			return {
				pageSize: 10,
				pageNum: 1,
				dataList: [],
				total: 0,
				sendFlag: 1, //1我收到的    2我发出的  默认是是收到
				templateType: 'SYSTEM' //REPLY  回复 SYSTEM  系统 FOLLOW  关注 LIKE  点赞
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
			this.getMessageList()
			this.getNumber()
		},
		methods: {
			async getNumber() {
				let param = {
					userId:  this.userId
				}
				ajaxParam(param)
				const res = await post('v1/message/getMessageUnreadCount', qs.stringify(param))
				if(res.data.code==200){
					let obj = res.data.entity
					this.numberComment = Number(obj.replyCount)
					this.numberSyetem = Number(obj.systemCount)
					this.numberLike = Number(obj.likeCount)
					console.log(this.numberComment)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取消息列表
			async getMessageList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userId:  this.userId,
					sendFlag: this.sendFlag,
					templateType: this.templateType
				}
				ajaxParam(param)
				const res = await post('v1/message/messageList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			pageChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getMessageList()
				this.getNumber()
			}
		}
	}
</script>

<style lang="less" scoped>
	
</style>
